<template>
  <div class="TermsWrapper">
    <div class="Terms">
      <div class="container">
        <TermsNavbar />
        <div class="TermsContainer">
          <div class="TermsContent">
            <h1>Pricing</h1>
            <div class="TermsTextBlock">
              <p>The price of the «Premium» account: 10 USD.</p>
              <p>
                By purchasing, you accept our
                <router-link to="/terms">Terms of service</router-link>.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import TermsNavbar from "./TermsNavbar";
import Footer from "./Footer";
export default {
  name: "Pricing",
  components: {
    TermsNavbar,
    Footer,
  },
};
</script>

<style lang="scss"></style>
